// extracted by mini-css-extract-plugin
export default {"date-holiday":"TimeLogsTable_date-holiday__Yf9Os","date-sunday":"TimeLogsTable_date-sunday__Cr2vA"};